import { BadRequestException, ConflictException, UnauthorizedException } from '@nestjs/common'

export class InvalidCredentialsException extends UnauthorizedException {
	constructor() {
		super('Invalid email or password')
	}
}

export class InvalidPasswordException extends BadRequestException {
	constructor() {
		super('Invalid password')
	}
}

export class UserEmailConflictException extends ConflictException {
	constructor() {
		super('A user with same email already exists')
	}
}
